import { Component } from '@angular/core';
import { MetforminComponent } from '@consultation-upsells/metformin/metformin.component';

@Component({
  selector: 'app-metformin-acne',
  imports: [MetforminComponent],
  templateUrl: './metformin-acne.component.html',
  styleUrl: './metformin-acne.component.scss',
})
export class MetforminAcneComponent {}
